import React from 'react';
import { Grid, Typography } from '@mui/material';
import ChannelPreviewList from '../../../ui/ChannelPreviewList';
import { FilterProvider, useFilter } from './FilterContext';
import FilterBar from './components/FilterBar';
import ChannelCardSkeleton from '../../../ui/ChannelCardSkeleton';

const SKELETON_ITEMS = Array.from({ length: 9 }, (_, index) => index);

const ChannelCardSkeletonGrid = () => (
    <Grid container spacing={2} data-testid="skeleton-card-grid">
        {SKELETON_ITEMS.map((item) => (
            <Grid
                key={item}
                size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                }}
            >
                <ChannelCardSkeleton />
            </Grid>
        ))}
    </Grid>
);

const ChannelsPageContent = () => {
    const { channels, loading } = useFilter();

    const renderContent = () => {
        if (loading) {
            return <ChannelCardSkeletonGrid />;
        }

        if (!channels?.length) {
            return (
                <Grid
                    container
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: 240,
                    }}
                >
                    <Typography
                        data-testid="channels-empty-state"
                        variant="body1"
                        align="center"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        No channels found.
                    </Typography>
                </Grid>
            );
        }

        return <ChannelPreviewList channels={channels} loading={loading} />;
    };

    return (
        <>
            <Grid id="channels-chips" size={12}>
                <FilterBar />
            </Grid>
            <Grid id="channels-list" size={12}>
                {renderContent()}
            </Grid>
        </>
    );
};

const ChannelsPage = () => {
    return (
        <FilterProvider>
            <Grid container spacing={2}>
                <ChannelsPageContent />
            </Grid>
        </FilterProvider>
    );
};

export default ChannelsPage;
